<script>
  import { onDestroy, onMount } from 'svelte';
  import Quill from 'quill';
  import setupMentions from './setupMentions';
  import setupClipboard from './setupClipboard';
  import MagicUrl from 'quill-magic-url';
  import parseHtmlToDelta from './parseHtmlToDelta';

  export let options = {},
    onChange = () => {},
    onPasteFromClipboard = () => {},
    initial = '',
    focused = false,
    toolbar = null;
  let quillContainer;
  let quillInstance;
  let editorContainer;

  let lastKnownRange = null;

  export const clear = () => {
    if (quillInstance) {
      const emptyHtml = quillInstance.clipboard.convert({ html: '' });
      quillInstance.setContents(emptyHtml, 'silent');
    }
  };

  export const focus = () => {
    focused = true;
    if (quillInstance) {
      quillInstance.focus();
    }
  };

  export const insertText = (text, options = { atCursor: true }) => {
    if (quillInstance) {
      const range = lastKnownRange || quillInstance.getSelection();
      if (options.atCursor && range) {
        quillInstance.insertText(range.index, text);
        quillInstance.setSelection(range.index + text.length);
      } else {
        quillInstance.insertText(0, text);
        quillInstance.setSelection(text.length);
      }
    }
  };

  onMount(() => {
    const quillConfig = {
      theme: 'snow',
      modules: {
        toolbar: toolbar
      },
      placeholder: M.TYPE_SOMETHING,
      ...options
    };
    setupMentions(Quill, quillConfig);
    Quill.register('modules/magicUrl', MagicUrl);
    quillInstance = new Quill(quillContainer, quillConfig);
    setupClipboard(quillInstance);

    editorContainer = quillContainer.getElementsByClassName('ql-editor')[0];

    // populate the editor with the initial value
    if (typeof initial === 'object' && initial.ops) {
      // If initial value is a Delta object
      quillInstance.setContents(initial, 'api');
    } else {
      // If initial value is regular HTML
      const initialHtml = parseHtmlToDelta(initial);
      quillInstance.setContents(initialHtml, 'api');
    }

    quillInstance.on('text-change', function (delta, oldDelta, source) {
      lastKnownRange = quillInstance.getSelection();
      onChange({
        html: editorContainer.innerHTML,
        text: quillInstance.getText()
      });
    });

    quillInstance.on('selection-change', function (range) {
      if (range) {
        lastKnownRange = range;
      }
    });

    editorContainer.addEventListener('paste', onPasteFromClipboard);

    if (focused) {
      quillInstance.focus();
    }
  });

  onDestroy(() => {
    if (editorContainer) {
      editorContainer.removeEventListener('paste', onPasteFromClipboard);
    }
  });
</script>

<div bind:this={quillContainer} />
